import IAction from "models/IAction";
import IStore from "models/IStore";
import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import MenuModel from "stores/menu/models/MenuModel";
import NavigationUtility from "utilities/NavigationUtility";

interface IProps {}
interface IStateToProps {
    readonly menuItems: MenuModel[];
    readonly pathname: string;
    readonly embeddedMode: boolean;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    menuItems: state.menu.menuItems,
    pathname: state.router.location.pathname,
    embeddedMode: state.config.embeddedMode,
});

const items = [
    {
        idVoceMenu: 1,
        codiceContenuto: "1a",
        idContenuto: 1,
        idElemento: 1,
        titolo: "Accessibilità",
        path: "accessibilita",
    } as MenuModel,
    {
        idVoceMenu: 2,
        codiceContenuto: "2a",
        idContenuto: 2,
        idElemento: 2,
        titolo: "Cookies",
        path: "cookies",
    } as MenuModel,
    {
        idVoceMenu: 3,
        codiceContenuto: "3a",
        idContenuto: 3,
        idElemento: 3,
        titolo: "Note Legali",
        path: "note-legali",
    } as MenuModel,
    {
        idVoceMenu: 4,
        codiceContenuto: "4a",
        idContenuto: 4,
        idElemento: 4,
        titolo: "Privacy Policy",
        path: "privacy-policy",
    } as MenuModel,
];

class Footer extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>> {
    private hasUnmounted = false;

    public componentDidMount(): void {
        //TODO: get menu items from backend
        // this.props.dispatch(MenuAction.menuGet());
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private redirectToPage = (page: string) => {
        NavigationUtility.redirectToPage(page);
    };

    public render(): JSX.Element | null {
        const { pathname, embeddedMode } = this.props;
        const year = new Date().getFullYear();
        if (embeddedMode) return <></>;
        return (
            <Navbar
                id="main-footer"
                className="bg-ocq-blue py-0 px-5 font-small"
                expand="sm"
                variant="light"
                color="light"
                fixed="bottom"
            >
                <Navbar.Brand className="mr-auto">
                    <span className="text-white text-center font-small">Copyright {year} Links</span>{" "}
                </Navbar.Brand>
                {false && (
                    <Nav className="justify-content-end text-center">
                        {items.map((model: MenuModel, i: number) => (
                            <Nav.Link
                                className={[
                                    "text-white",
                                    NavigationUtility.checkIfIsCurrentPage(pathname, "/" + model.path)
                                        ? "font-weight-bolder"
                                        : "",
                                ].join(" ")}
                                key={i}
                                onClick={() => this.redirectToPage("/" + model.path)}
                            >
                                <span
                                    className={[
                                        "d-none d-lg-inline",
                                        i < items.length - 1 ? "pr-3 border-right border-white" : "",
                                    ].join(" ")}
                                >
                                    {model.titolo}
                                </span>
                                <span className="d-lg-none">{model.titolo}</span>
                            </Nav.Link>
                        ))}
                    </Nav>
                )}
            </Navbar>
        );
    }
}

export { Footer as Unconnected };
export default connect(mapStateToProps)(Footer);
